import React, { createContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { emptyObject } from "constants/defaultValues";

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [appContext, setAppContext] = useState(emptyObject);
  const value = useMemo(() => ({ appContext, setAppContext }), [appContext, setAppContext]);
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

AppContextProvider.propTypes = { children: PropTypes.element.isRequired };
